import { render, staticRenderFns } from "./Cellpuri.vue?vue&type=template&id=7164963c&scoped=true&"
import script from "./Cellpuri.vue?vue&type=script&lang=js&"
export * from "./Cellpuri.vue?vue&type=script&lang=js&"
import style0 from "./Cellpuri.vue?vue&type=style&index=0&id=7164963c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164963c",
  null
  
)

export default component.exports